import sp_icon from "../../../../../../../Project/allProjectsPage/ProjectsTable/assets/sp_icon.png";

export const attachmentsTableCols = [
  {
    header: "#",
    accessorFn: (row, rowIndex) => rowIndex + 1,
    size: 10,
    enableSorting: false,
    enableEditing: false,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Edit: () => <></>,
  },

  {
    accessorKey: "DocNumber",
    header: "Doc #",
    // enableEditing: false,
    grow: false,
    size: 60,
  },
  {
    accessorKey: "description",
    header: "Doc Description",
    // enableEditing: false,
    grow: false,
    size: 60,
  },
  {
    accessorKey: "revision",
    header: "Rev #",
    // enableEditing: false,
    grow: false,
    size: 60,
  },
  {
    accessorKey: "link",
    header: "Link",
    // enableEditing: false,
    grow: false,
    size: 60,
    Cell: ({ cell, row }) => {
      const dcsLink = cell.getValue();

      return (
        <a href={dcsLink} target="_blank" rel="noopener noreferrer">
          <img src={sp_icon} height={"40px"} alt="SharePoint" />
        </a>
      );
    },
  },
];
